module.exports = __webpack_public_path__ + "static/media/logotype-white.2728dece.svg";